import {Module} from "../index";
import messages from "./resources/messages";
import {routes} from "./resources/routes";
import {GameCreationEventSubscriber} from "./subscribers/GameCreationEventSubscriber";
import GateManager from "@/modules/action-points/services/GateManager";
import {GateTypeEnum} from "@/modules/action-points/enums";
import ScoutingActionPointsCurrency from "@/modules/action-points/services/ScoutingActionPointsCurrency";
import NegotiationActionPointsCurrency from "@/modules/action-points/services/NegotiationActionPointsCurrency";
import GateScouting from "./components/GateScouting.vue";
import GateNegotiation from "./components/GateNegotiation.vue";
import GateTrainingGK from "./components/GateTrainingGK.vue";
import GateTrainingDF from "./components/GateTrainingDF.vue";
import GateTrainingMF from "./components/GateTrainingMF.vue";
import GateTrainingAT from "./components/GateTrainingAT.vue";
import GateCoins from "./components/GateCoins.vue";
import GateBalance from "./components/GateBalance.vue";
import {
  ActionPointsGenerationEventSubscriber
} from "@/modules/action-points/subscribers/ActionPointsGenerationEventSubscriber";
import TrainingGKActionPointsCurrency from "@/modules/action-points/services/TrainingGKActionPointsCurrency";
import TrainingDFActionPointsCurrency from "@/modules/action-points/services/TrainingDFActionPointsCurrency";
import TrainingMFActionPointsCurrency from "@/modules/action-points/services/TrainingMFActionPointsCurrency";
import TrainingATActionPointsCurrency from "@/modules/action-points/services/TrainingATActionPointsCurrency";
import CoinsActionPointsCurrency from "@/modules/action-points/services/CoinsActionPointsCurrency";
import CoinsCurrencyExchanger from "@/modules/action-points/services/CoinsCurrencyExchanger";
import {CoinsSellerInterface} from "@/modules/action-points/interfaces";
import WebMockCoinsSeller from "@/modules/action-points/services/coins-seller-web/WebMockCoinsSeller";
import {TYPES} from "@/modules/action-points/types";
import {isPlatform} from '@ionic/vue';
import RevenueCatCoinsSeller from "@/modules/action-points/services/coins-seller-revenue-cat/RevenueCatCoinsSeller";
import NotificationEventSubscriber from "@/modules/action-points/subscribers/NotificationEventSubscriber";
import {CoinsPurchasedNotification, CurrencyExchangeNotification} from "@/modules/action-points/entity";
import BalanceActionPointsCurrency from "@/modules/action-points/services/BalanceActionPointsCurrency";

export class ActionPointsModule extends Module {
  messages = messages;
  routes = routes;

  public entities = [
    CoinsPurchasedNotification,
    CurrencyExchangeNotification,
  ];

  eventSubscribers = [
    GameCreationEventSubscriber,
    NotificationEventSubscriber,
    ActionPointsGenerationEventSubscriber,
  ];

  protected register() {
    super.register();

    this.app.bind<CoinsCurrencyExchanger>(CoinsCurrencyExchanger).to(CoinsCurrencyExchanger);
    this.app.bind<WebMockCoinsSeller>(WebMockCoinsSeller).to(WebMockCoinsSeller);
    this.app.bind<RevenueCatCoinsSeller>(RevenueCatCoinsSeller).to(RevenueCatCoinsSeller);

    // todo remove/add android/ios coin sellers
    // if (isPlatform('mobileweb') || isPlatform('desktop')) {
      this.app.bind<CoinsSellerInterface>(TYPES.CoinsSeller).to(WebMockCoinsSeller);
    // }

    // if (isPlatform('android')) {
    // this.app.bind<CoinsSellerInterface>(TYPES.CoinsSeller).to(RevenueCatCoinsSeller);
    // }

    this.app.bind<ScoutingActionPointsCurrency>(ScoutingActionPointsCurrency).to(ScoutingActionPointsCurrency);
    this.app.bind<NegotiationActionPointsCurrency>(NegotiationActionPointsCurrency).to(NegotiationActionPointsCurrency);
    this.app.bind<TrainingGKActionPointsCurrency>(TrainingGKActionPointsCurrency).to(TrainingGKActionPointsCurrency);
    this.app.bind<TrainingDFActionPointsCurrency>(TrainingDFActionPointsCurrency).to(TrainingDFActionPointsCurrency);
    this.app.bind<TrainingMFActionPointsCurrency>(TrainingMFActionPointsCurrency).to(TrainingMFActionPointsCurrency);
    this.app.bind<TrainingATActionPointsCurrency>(TrainingATActionPointsCurrency).to(TrainingATActionPointsCurrency);
    this.app.bind<CoinsActionPointsCurrency>(CoinsActionPointsCurrency).to(CoinsActionPointsCurrency);
    this.app.bind<BalanceActionPointsCurrency>(BalanceActionPointsCurrency).to(BalanceActionPointsCurrency);

    this.app.bind<GateManager>(GateManager).toConstantValue(
      new GateManager({
        [GateTypeEnum.SCOUTING]: {
          currency: this.app.get(ScoutingActionPointsCurrency),
          component: shallowRef(GateScouting),
        },
        [GateTypeEnum.NEGOTIATION]: {
          currency: this.app.get(NegotiationActionPointsCurrency),
          component: shallowRef(GateNegotiation),
        },
        [GateTypeEnum.TRAINING_GK]: {
          currency: this.app.get(TrainingGKActionPointsCurrency),
          component: shallowRef(GateTrainingGK),
        },
        [GateTypeEnum.TRAINING_DF]: {
          currency: this.app.get(TrainingDFActionPointsCurrency),
          component: shallowRef(GateTrainingDF),
        },
        [GateTypeEnum.TRAINING_MF]: {
          currency: this.app.get(TrainingMFActionPointsCurrency),
          component: shallowRef(GateTrainingMF),
        },
        [GateTypeEnum.TRAINING_AT]: {
          currency: this.app.get(TrainingATActionPointsCurrency),
          component: shallowRef(GateTrainingAT),
        },
        [GateTypeEnum.COINS]: {
          currency: this.app.get(CoinsActionPointsCurrency),
          component: shallowRef(GateCoins),
        },
        [GateTypeEnum.BALANCE]: {
          currency: this.app.get(BalanceActionPointsCurrency),
          component: shallowRef(GateBalance),
        },
      })
    );
  }

  boot() {
    super.boot();
  }
}
